import HeaderBar from "components/HeaderBar";
import Loading from "components/Loading";
import Page from "components/Page";
import { useState } from "react";
import { certGETj } from "lib/API";
import Input from "components/Input";
import { ButtonPrimary } from "components/Buttons";

export default function SearchEngine() {
  const [searchArray, setSearchArray] = useState([""]);
  function handleSet(k, v) {
    setSearchArray((sa) => sa.map((sam, sami) => (sami === k ? v : sam)));
  }
  const s = searchArray.map((sa) => sa.trim()).join("");
  const disabled = !s;

  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  async function doSearch() {
    setLoading(true);
    const r = await certGETj(
      `searchEngines?${searchArray.map((s) => `search=${encodeURIComponent(s)}`).join("&")}`,
    );
    if (r.success) {
      setResults(r.data);
      setLoading(false);
    }
  }

  return (
    <Page title="Search Engine N°">
      {loading ? (
        <Loading />
      ) : (
        <>
          <HeaderBar>
            {searchArray.map((sa, sai) => (
              <Input
                key={sai}
                value={sa}
                setValue={(v) => handleSet(sai, v)}
                label={`Search`}
                onEnter={doSearch}
              />
            ))}
            <div className="btn-group mt-4">
              <ButtonPrimary onClick={doSearch} disabled={disabled}>
                Search &gt;&gt;
              </ButtonPrimary>
            </div>
          </HeaderBar>
          <div className="py-2 px-4">
            {results?.length === 0 && <p>No results</p>}
            {results?.length > 0 && (
              <table>
                <thead>
                  <tr>
                    <th>Engine number</th>
                    <th>VIN</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((r) => (
                    <tr key={`${r.engineNumber}${r.vin}`}>
                      <td className="border-r pr-2 text-right">
                        {r.engineNumber}
                      </td>
                      <td className="border-l pl-2 text-left">{r.vin}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </Page>
  );
}
